<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    menuOptions: { label: string; action: () => void }[];
    id?: string;
    mainContextMenu?: boolean;
  }>(),
  {
    id: useIdentifier(),
    mainContextMenu: false,
  },
);

const { $trackEvent } = useNuxtApp();
const rightClicked = defineModel<boolean>();
const open = ref<boolean>(false);

const handleClose = () => {
  if (open.value) {
    open.value = false;
    rightClicked.value = false;
  }
};
watchEffect(() => {
  if (rightClicked.value) {
    open.value = true;
    rightClicked.value = false;
  }
});
watch(open, (isOpen) => {
  if (!isOpen) {
    rightClicked.value = false;
    return props.mainContextMenu
      ? $trackEvent('Notification', 'NOTIFICATION_PANEL_CONTEXT_MENU_CLOSE')
      : $trackEvent('Notification', 'NOTIFICATION_CONTEXT_MENU_CLOSE');
  } else
    return props.mainContextMenu
      ? $trackEvent('Notification', 'NOTIFICATION_PANEL_CONTEXT_MENU_OPEN')
      : $trackEvent('Notification', 'NOTIFICATION_CONTEXT_MENU_OPEN');
});
onUnmounted(() => {
  open.value = false;
});
</script>
<template>
  <DesignSystemContextMenu
    v-model:open="open"
    :items="menuOptions"
    @click-outside="handleClose"
  />
</template>
